import { ELEMENT_IDS } from "features/bookmarks/utils";

/** Pointer events report viewport coords; the reducer stores container-relative ones. */
export function getContainerOrigin(): { x: number; y: number } {
    const container = document.getElementById(ELEMENT_IDS.renderContainer);
    if (!container) {
        return { x: 0, y: 0 };
    }
    const rect = container.getBoundingClientRect();
    return { x: rect.left, y: rect.top };
}

/** Geometry snapshotted at drag activation so subsequent `pointermove`s don't re-read the DOM. */
export interface DragGrabCapture {
    grabOffset: { x: number; y: number };
    containerOrigin: { x: number; y: number };
}

export function positionFromPointer(
    clientX: number,
    clientY: number,
    capture: DragGrabCapture,
): { x: number; y: number } {
    return {
        x: clientX - capture.grabOffset.x - capture.containerOrigin.x,
        y: clientY - capture.grabOffset.y - capture.containerOrigin.y,
    };
}
